module.exports = __webpack_public_path__ + "static/media/home-icon-inactive.04863c4b.svg";